import { render, staticRenderFns } from "./SectionPromotion.vue?vue&type=template&id=1119b08a&"
import script from "./SectionPromotion.vue?vue&type=script&lang=js&"
export * from "./SectionPromotion.vue?vue&type=script&lang=js&"
import style0 from "./SectionPromotion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports